/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_4Inputs */

const en_cap_full_mock_4 = /** @type {(inputs: Cap_Full_Mock_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Models`)
};

const lv_cap_full_mock_4 = /** @type {(inputs: Cap_Full_Mock_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modeļi`)
};

/**
* | output |
* | --- |
* | "Models" |
*
* @param {Cap_Full_Mock_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_4 = /** @type {((inputs?: Cap_Full_Mock_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_4(inputs)
	return en_cap_full_mock_4(inputs)
});